import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const adalo = defineConnector({
  identifier: "adalo",
  name: "Adalo",
  tagLine: "No-code app builder",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.adalo\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Adalo](https://www.adalo.com/), open your app, then go to **Settings → App Access → API** to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "App ID",
          required: true,
          target: { kind: "configuration", field: "appId" },
          helperText: "Your Adalo app ID, found in the app URL.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ appId }) =>
      `https://api.adalo.com/v0/apps/${appId}/collections`,
  },
});
